import { styled, alpha } from '@mui/material/styles';
import { IconButton, Select } from '@mui/material';

import bgUrl from '@images/mainBg.png';
import COLORS from '@styles/theme/colors';
import { url } from 'inspector';

interface IconWrap {
  color: string;
}

interface RowLine {
  color: string;
}
interface LabelProps {
  color: string;
}

interface StatusProps {
  textcolor: string;
  bgcolor: string;
  cursor: string;
  width: number | string;
  minwidth: number | string;
}

export const StatusSwither = styled('div')<StatusProps>(({ theme, textcolor, bgcolor, width, minwidth, cursor }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  minWidth: minwidth || 85,
  fontSize: 12,
  fontWeight: theme.typography.fontWeightMedium,
  color: textcolor,
  width: width,
  minHeight: 'auto',
  padding: `${theme.spacing(0.5, 1, 0.5)} !important`,
  borderRadius: 4,
  backgroundColor: bgcolor,
  cursor: cursor || 'pointer',
  transition: 'all .3s ease',

  '&:hover': {
    backgroundColor: textcolor && alpha(textcolor, .2)
  },

  '& svg': {
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    left : '50%',
    color: textcolor
  },

  '& .MuiIconButton-root': {
    position: 'relative'
  },
}));

export const Body = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundImage: `url(${bgUrl})`,
  backgroundRepeat: 'none',
  backgroundSize: 'cover',
  position: 'relative',
  backgroundPosition: 'center center'
}));

export const MainBody = styled('div')(({ theme }) => ({
  minHeight: 'calc(100vh - 100px)',
  display: 'flex',
  flexDirection: 'column',
  backgroundImage: `url(${bgUrl})`,
  backgroundRepeat: 'none',
  position: 'relative',
  backgroundSize: 'cover',
  backgroundPosition: 'center center'
}));

export const Container = styled('div')(({ theme }) => ({
  maxWidth: 1180,
  width: '100%',
  flex: '1',
  display: 'flex',
  flexDirection: 'column'
}));

export const HeadTitle = styled('div')(({ maxwidth }) => ({
  maxWidth: maxwidth || 380,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export const HeadSubTitle = styled('div')(({ maxWidth }) => ({
  fontSize: 12,
  fontWeight: 400,
  maxWidth: maxWidth || 380,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export const IconWrap = styled('div')<IconWrap>(({ color }) => ({
  width: 16,
  backgroundColor: color,
  height: 16,
  borderRadius: 4,
  display: 'flex',

  '& > *': {
    margin: 'auto'
  }
}));

export const SelectWidthIcon = styled(Select)({
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center'
  }
});

export const FlexBox = styled('div')({
  display: 'flex',
  alignItems: 'center'
});

export const TableRowLine = styled('div')<RowLine>(({ color }) => ({
  position: 'absolute',
  width: 2,
  left: 0,
  top: 0,
  height: '100%',
  backgroundColor: color
}));

export const Label = styled('div')<LabelProps>(({ theme, color }) => ({
  color: color,
  backgroundColor: alpha(color, .1),
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0.4, 0.7),
  borderRadius: 5,
  fontWeight: theme.typography.fontWeightMedium,

  'svg': {
    flex: ' 0 0 auto',
    marginRight: theme.spacing(1)
  }
}));

export const ScrollableWrapper = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb, &::-webkit-scrollbar': {
    width: 3,
    height: 3,
    background: '#fff',
    borderRadius: 10,
    cursor: 'pointer',
  },

  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.primary.main
  }
}));

export const SquareIconButton = styled(IconButton)(({ theme }) => ({
  borderRadius: 4,
  backgroundColor: COLORS.white,
  border: `1px solid ${COLORS.textSecondColorLight}`
}));
